/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $CountryList = {
    type: 'array',
    contains: {
        type: 'Country',
    },
} as const;
